export default __webpack_public_path__ + "static/media/ExcelIcon.fc003f5d.svg";